import { Component, Vue, Watch } from 'vue-property-decorator';
import PageHeader from '@/components/page-header/PageHeader';
import { Order } from '@/models/Order';
import { User } from '@/models/User';
import { OrderItem } from '@/models/OrderItem';
import { Payment } from '@/models/Payment';
import { identifyHostname } from '@/support/Client';
import { formatDate } from '@/support/String';
import { AxiosResponse, AxiosError } from 'axios';
import ErrorHandler from '@/support/ErrorHandler';


@Component<OrderFee>({
  components: {
    PageHeader,
  },
  filters: {
    formatDate(date: string) {
      if(!date) {
        return '';
      }

      return formatDate(date);
    },
  }
})
export default class OrderFee extends Vue {
  public $pageTitle = 'Sale order';

  protected isEditing: boolean = false;
  protected saleOrder: Order = new Order();
  protected user: User = new User();
  protected orderItems: OrderItem[] = [];
  protected payments: Payment[] = [];
  public oAuthServer: string = identifyHostname() || '';

  public mounted() {
    new Order()
    .include(['user', 'order-items', 'payments', 'product'])
    .find(this.$route.params.id)
    .then((saleOrder: Order) => {
      this.saleOrder = saleOrder;
      this.user = saleOrder.user as User;
      this.orderItems = saleOrder.order_items as OrderItem[];
      this.payments = saleOrder.payments as Payment[];

      this.$root.$emit('breadcrumbUpdated',
      {
        crumb: [
          // @ts-ignore
          { name: this.$route.meta.name, path: `/styling-fees` },
          { name: `Styling fee` },
        ],
      });
    });
  }

  protected getPdf(download: boolean = false) {
    if(!this.saleOrder.links.invoice) {
      return;
    }

    new Order()
    .downloadPdf(this.saleOrder.links.invoice)
    .then((response: AxiosResponse) => {
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' } ));
      if(!download) {
        window.open(url);
      } else {
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `styling-fee.pdf`);
        document.body.appendChild(link);
        link.click();
      }
    })
    .catch((error: AxiosError) => {
      ErrorHandler.network(error);
    })
  }
}



interface HTMLInputEvent extends Event {
  target: HTMLInputElement & EventTarget;
}
